export default "__VITE_ASSET__CjL5tJcw__"